// Display a link beneath these questions to toggle the address mode
export const QUESTIONS_WITH_TOGGLE: string[] = [
  "uk_postcode",
  "customer[uk_postcode]",
];
